module.exports = __webpack_public_path__ + "img/image2.52283bdc.png";